// extracted by mini-css-extract-plugin
export default {"root":"StuTable_root__CO4Vh","student":"StuTable_student__QxeSW","button":"StuTable_button__XU-Tp","roots":"StuTable_roots__PcRAN"};